import axios from "axios";
import { API_URL } from "@/helpers";

export const settingService = {
  getSettings,
  getGeoData,

  addPilot,
  updatePilot,
  deletePilot,

  addDrone,
  updateDrone,
  deleteDrone,

  addProject,
  updateProject,
  deleteProject,

  getDroneMaintenance,
  addDroneMaintenance,
  getPilotTraining,
  addPilotTraining,

  manageLiveStream
};

export function getSettings() {
  return axios.get(`${API_URL}/1/settings/`);
}

export function getGeoData(longitude, latitude) {
  return axios.get(`${API_URL}/1/airports/geodata/${longitude}/${latitude}`);
}

export function addPilot(pilot) {
  return axios
    .post(
      `${API_URL}/1/settings/pilots/`,
      (({
        firstname,
        lastname,
        license,
        licenseType,
        licenseData,
        licenseFile,
        fileType,
        phone,
        email,
        pilot,
        threshold,
        observer,
        payloadOperator,
        superuser
      }) => ({
        firstname,
        lastname,
        license,
        licenseType,
        licenseData,
        licenseFile,
        fileType,
        phone,
        email,
        pilot,
        threshold,
        observer,
        payloadOperator,
        superuser
      }))(pilot)
    )
    .then(response => {
      return response.data;
    });
}

export function updatePilot(position, pilot) {
  return axios
    .post(
      `${API_URL}/1/settings/pilots/${position}`,
      (({
        firstname,
        lastname,
        license,
        licenseType,
        licenseData,
        licenseFile,
        fileType,
        phone,
        email,
        pilot,
        threshold,
        observer,
        payloadOperator,
        superuser
      }) => ({
        firstname,
        lastname,
        license,
        licenseType,
        licenseData,
        licenseFile,
        fileType,
        phone,
        email,
        pilot,
        threshold,
        observer,
        payloadOperator,
        superuser
      }))(pilot)
    )
    .then(response => {
      return response.data;
    });
}

export function deletePilot(position) {
  return axios.delete(`${API_URL}/1/settings/pilots/${position}`);
}

export function addDrone(drone) {
  return axios.post(
    `${API_URL}/1/settings/drones/`,
    (({
      manufacturer,
      model,
      nickname,
      serialno,
      weightLessThan250g,
      registrationnumber,
      certificateData,
      certificateFile,
      fileType,
      color,
      threshold,
      wilcoid,
      availability,
      pilots
    }) => ({
      manufacturer,
      model,
      nickname,
      serialno,
      weightLessThan250g,
      registrationnumber,
      certificateData,
      certificateFile,
      fileType,
      color,
      threshold,
      wilcoid,
      availability,
      pilots
    }))(drone)
  );
}

export function updateDrone(position, drone) {
  return axios.post(
    `${API_URL}/1/settings/drones/${position}`,
    (({
      manufacturer,
      model,
      nickname,
      serialno,
      weightLessThan250g,
      registrationnumber,
      certificateData,
      certificateFile,
      fileType,
      color,
      threshold,
      wilcoid,
      availability,
      pilots
    }) => ({
      manufacturer,
      model,
      nickname,
      serialno,
      weightLessThan250g,
      registrationnumber,
      certificateData,
      certificateFile,
      fileType,
      color,
      threshold,
      wilcoid,
      availability,
      pilots
    }))(drone)
  );
}

export function deleteDrone(position) {
  return axios.delete(`${API_URL}/1/settings/drones/${position}`);
}

export function addProject(project) {
  return axios.post(
    `${API_URL}/1/settings/projects/`,
    (({ name, pilots, superusers, observers, payloadOperators, drones }) => ({
      name,
      pilots,
      superusers,
      observers,
      payloadOperators,
      drones
    }))(project)
  );
}

export function updateProject(position, project) {
  return axios.post(
    `${API_URL}/1/settings/projects/${position}`,
    (({ name, pilots, superusers, observers, payloadOperators, drones }) => ({
      name,
      pilots,
      superusers,
      observers,
      payloadOperators,
      drones
    }))(project)
  );
}

export function deleteProject(position) {
  return axios.delete(`${API_URL}/1/settings/projects/${position}`);
}

export function getDroneMaintenance() {
  return axios.get(`${API_URL}/1/settings/maintenance/drone/`);
}

export function addDroneMaintenance(record) {
  return axios.post(
    `${API_URL}/1/settings/maintenance/drone/`,
    (({ registrationnumber, timestamp, details }) => ({
      registrationnumber,
      timestamp,
      details
    }))(record)
  );
}

export function getPilotTraining() {
  return axios.get(`${API_URL}/1/settings/training/pilot/`);
}

export function addPilotTraining(record) {
  return axios.post(
    `${API_URL}/1/settings/training/pilot/`,
    (({ license, timestamp, details }) => ({
      license,
      timestamp,
      details
    }))(record)
  );
}

export function manageLiveStream(projectName) {
  return axios.post(`${API_URL}/1/settings/livestream/${projectName}`);
}
